import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface RemovedItemObject {
    productId?: string | null;
    productName?: string;
    productQty?: number | null;
    productUoM?: string;
    productUrl?: string;
}

export interface RemovedItemParameter extends ApiParameter {
    removedItem?: RemovedItemObject;
    removedSave?: RemovedItemObject;
}

export interface RemovedItemModel {
    productId?: string;
    productName?: string;
    productQty?: number | null;
    productUoM?: string;
}

type HandlerType = CustomApiHandler<RemovedItemParameter, RemovedItemModel>;

export const DispatchRemovedItem: HandlerType = (props: any) => {
    props.dispatch({
        type: "HomePage/RemovedItem",
        result: props.parameter,
    });
};

export const chain = [DispatchRemovedItem];

const actionRemovedItem = createHandlerChainRunnerOptionalParameter(chain, {}, "actionRemovedItem");
export default actionRemovedItem;
